module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-body-blockquote",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "quote-container"
  }, [_vm._l((_vm.itemQuotes), function(quote, index) {
    return [_c('div', {
      key: index,
      class: [_vm.quoteClassName(quote.quoteType), 'quote']
    }, [_c('div', {
      staticClass: "quotes"
    }, [_c('div', {
      staticClass: "quotes__icon"
    }, [_c('single-quote-svg')], 1), _c('div', {
      staticClass: "quotes__icon"
    }, [_c('single-quote-svg')], 1)]), _vm._v("\n        " + _vm._s(quote.value) + "\n      ")])]
  })], 2), _c('div', {
    staticClass: "share-buttons-container"
  }, [_c('amp-share-pane', {
    attrs: {
      "node": _vm.node,
      "mode": 'blockquote',
      "quote": _vm.shareTitle
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3065d5f2","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpBlockquote.vue
// module id = 1734
// module chunks = 34